import { render } from "./ArrowDetail.vue?vue&type=template&id=68aa0d63"
import script from "./ArrowDetail.vue?vue&type=script&lang=js"
export * from "./ArrowDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__